<script>
  // imports
  import SectionDefault from './SectionDefault.svelte';
  import SectionHero from './SectionHero.svelte';

  //exports
  export let data;
</script>

{#if data.blockParallax}
  <SectionHero data={data}>
    <slot></slot>
  </SectionHero>
{:else}
  <SectionDefault data={data}>
    <slot></slot>
  </SectionDefault>
{/if}